import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["placeholder", "value"]
const _hoisted_2 = ["value"]

import { SolrFacet, SolrFacetOption } from '../../modules/solr'; // eslint-disable-line import/no-relative-parent-imports


export default /*#__PURE__*/_defineComponent({
  __name: 'FacetOptionsSingleDropdown',
  props: {
    facet: {}
  },
  emits: ["change"],
  setup(__props: any, { emit }) {

const props = __props;





function key (option: SolrFacetOption): string {
    return `${option.label}|${option.value}|${option.selected ? 'y' : 'n'}}`;
}

function selectedOption (): string {
    for (const [key, option] of Object.entries(props.facet.options)) {
        if (option.selected) {
            return option.value;
        }
    }
    return '';
}

function changeValue (event: Event): void {
    emit('change', props.facet.name, (event.target as HTMLInputElement).value, 'set');
}

function sortedReverse (options: SolrFacetOption[]): SolrFacetOption[] {
    return options.sort((a, b) => b.label.localeCompare(a.label));
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("sl-select", {
    placeholder: props.facet.label,
    onSlChange: changeValue,
    value: selectedOption()
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedReverse(props.facet.options), (option) => {
      return (_openBlock(), _createElementBlock("sl-option", {
        key: key(option),
        value: option.value
      }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1))
}
}

})